module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        showColorBar: true,
        tabConfigNavKey: 'schoolVacation',
        parentEntityPreparationGranted: false,
        showEditByMySelf: true,
    },
}